import {Component, inject, Input} from '@angular/core';
import {ProductService} from '../../services/product.service'
import {CartProduct, ProductCustomer, StoreService} from 'compob2b-libs'
import {NgClass, NgIf} from '@angular/common'
import {translations} from '../../../../../environments/translations.ru'
import {Columns} from 'compob2b-table'
import {NbTooltipModule} from '@nebular/theme'

@Component({
  selector: 'app-product-wms',
  imports: [
    NgIf,
    NgClass,
    NbTooltipModule
  ],
  templateUrl: './product-wms.component.html',
  styleUrl: './../product-list.component.scss'
})
export class ProductWmsComponent {
  @Input() product: ProductCustomer | CartProduct
  @Input() column: Columns;

  productService = inject(ProductService);
  storeService = inject(StoreService);

  protected readonly translations = translations

  get unitHeader(): string {
    return this.product?.unitHeader?.replace(/\.+$/, "");
  }
}
